import { FileMetaData } from '@modeso/types__aumico-lib-companies-be';

export interface DocumentModel {
    documentId: string;
    name: string;
    taskId?: string;
    isPermanent: boolean;
    expiryDate?: Date;

    // It's either a file upload or an external link
    externalLinkUrl?: string;
    filesMetaData?: FileMetaData;

    // Optional fields for saved documents
    id: string;
    organizationId: string;
    projectId: string;
}
